// Where to send the user after they sign in, when they arrived on a protected in-app page while logged out
// (e.g. an AI assistant's OAuth consent screen, /oauth/consent?request=…). Kept in localStorage so it
// survives the whole "create account → verify email → log in" detour and Google sign-in redirects.
const KEY = 'vte_post_auth_redirect'
const TTL_MS = 60 * 60 * 1000

/** Same-origin relative paths only — never an absolute URL or protocol-relative //host. */
export function isSafeAppPath(value: unknown): value is string {
  return typeof value === 'string' && value.startsWith('/') && !value.startsWith('//') && !value.startsWith('/\\')
}

export function rememberPostAuthRedirect(path: string) {
  if (!isSafeAppPath(path)) return
  try { localStorage.setItem(KEY, JSON.stringify({ path, exp: Date.now() + TTL_MS })) } catch { /* private mode */ }
}

export function peekPostAuthRedirect(): string | null {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    const { path, exp } = JSON.parse(raw) as { path?: unknown; exp?: number }
    if (!isSafeAppPath(path) || !exp || exp < Date.now()) {
      localStorage.removeItem(KEY)
      return null
    }
    return path
  } catch {
    return null
  }
}

export function takePostAuthRedirect(): string | null {
  const path = peekPostAuthRedirect()
  try { localStorage.removeItem(KEY) } catch { /* private mode */ }
  return path
}

/** True while an AI assistant connection is waiting for the user to sign in or sign up. */
export function hasPendingAgentConnection(): boolean {
  return (peekPostAuthRedirect() || '').startsWith('/oauth/consent')
}
